'use client';
import Link from 'next/link';
import {useState} from 'react';

export default function Footer() {
  const [isActive, setIsActive] = useState(false);

  const handleClick = () => {
    setIsActive(!isActive);
  };
  return (
    <>
      <div id='footer'>
        <div className='footer_inner'>
          <ul className='f_list'>
            <li>
              <Link href='#n'>회사소개</Link>
            </li>
            <li>
              <Link href='#n'>서비스 소개</Link>
            </li>
            <li>
              <Link href='#n'>광고 안내</Link>
            </li>
            <li>
              <Link href='#n'>인재채용</Link>
            </li>
            <li>
              <Link href='#n'>이용약관</Link>
            </li>
            <li>
              <Link href='#n'>
                <strong>개인정보처리방침</strong>
              </Link>
            </li>
            <li>
              <Link href='#n'>청소년보호정책</Link>
            </li>
            <li>
              <Link href='#n'>운영정책</Link>
            </li>
            <li>
              <Link href='#n'>권리침해신고센터</Link>
            </li>
            <li>
              <Link href='#n'>고객센터</Link>
            </li>
            <li>
              <Link href='#n'>오픈스튜디오</Link>
            </li>
            <li>
              <Link href='#n'>Developers</Link>
            </li>
            <li>
              <Link href='#n'>주요서비스</Link>
            </li>
            <li className={`familysite ${isActive ? 'on' : ''}`}>
              <button id='familylBtn' onClick={handleClick}>
                패밀리 사이트
              </button>
              <div className='flayer' id='familyLayer'>
                <ul>
                  <li>
                    <Link href='#n'>Apro</Link>
                  </li>
                  <li>
                    <Link href='#n'>CAPPY</Link>
                  </li>
                  <li>
                    <Link href='#n'>SAYBUZZ</Link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
          <div className='adr'>
            주식회사 숲<span>대표이사 : 서수길, 최영우</span>
            <span>사업자번호 : 220-81-10886</span>
            <span>통신판매번호 제2010-경기성남-0834</span>
            <span>
              <Link
                href='http://ftc.go.kr/bizCommPop.do?wrkr_no=2208110886&apv_perm_no='
                target='_blank'>
                사업자 정보 확인
              </Link>
            </span>
            <span>호스팅 제공자 : 주식회사 숲</span>
            <div>
              <address>
                주소 : 경기도 성남시 분당구 판교로228번길 15 판교세븐밴처밸리
                1단지 주식회사 숲(삼평동)
              </address>
              <span>FAX : 031-622-8008</span>
              <span>
                <Link
                  href='mailto:afreecaTV@afreecatv.com'
                  className='mail'
                  title='메일'>
                  soop@sooplive.com
                </Link>{' '}
                (1688-7022)
              </span>
            </div>
          </div>
          <p className='copyright'>ⓒ SOOP Corp.</p>
        </div>
      </div>
    </>
  );
}
